module.exports = require('./helpers/bundle-url').getBundleURL('1xtho') + "logo.7718c6df.svg";